<template>
  <modal
    width="580px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="quit"
    class="privacy-modal"
  >
    <p slot="header">隐私协议</p>
    <div slot="content" class="main-content">
      <p class="title">组委会在线考试\比赛系统用户隐私政策</p><br/>
      <div class="text">
        各位监护人及参赛选手：<br/>
        为确保考试\比赛的公正公平，本场考试\比赛将采用在线监考方式推进。隐私权是未成年重要的权利。组委会（以下称“我们”）重视且尊重青少年用户隐私。在选手使用组委会的比赛系统进行在线比赛时，选择下方“确定”按钮继续参与比赛流程，即表示您同意我们按照政策对本场线上比赛用户信息进行收集、存储、使用等。我们除了会严格按照《用户隐私政策》中的规定来使用您的个人信息外，此外还将涉及本文中的场景。
        <br/><br/>信息收集及使用：<br/>
        <ol>
          <li>在开始比赛之前和比赛过程中，需要您开启摄像头、麦克风，获取您的面部图像与声音，以进行身份核验与比赛监控；</li>
        </ol>
        <br/>信息储存及保护：<br/>
        <ol>
          <li>在未征得您事先许可的情况下，我们不会将这些信息对外披露或向第三方提供。</li>
          <li>我们采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的信息遭到未经授权的访问使用和修改，避免数据的损坏或丢失。</li>
          <li>我们仅允许有必要知晓这些信息的组委会管理员访问您的信息（以核实身份信息和比赛情况），并为此设置了严格的访问权限控制和监控机制。</li>
        </ol>
        <br/>
        其他信息收集及使用情形均按照组委会《用户隐私政策》中的说明。<br/>
        如果您有任何疑问、意见或建议，请与我们联系。
      </div>
    </div>
    <div slot="footer">
      <button class="white-btn" @click="quit">不同意</button>
      <button class="blue-btn" @click="submit">同意</button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    quit () {
      this.$router.push({ name: 'list' })
    },
    submit () {
      this.$emit('nextStep', 0)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .modal-head {
  padding: 16px 20px;
  border-bottom: 1px solid #F1F1F1;
}
.main-content {
  max-height: 500px;
  overflow-y: scroll;
}
.text {
  font-size: 14px;
  color: #333;
  line-height: 28px;
  ol li {
    list-style: disc inside;
  }
}
.title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: center;
}
.white-btn {
  @include cancel-btn(96px, 36px, 14px, 4px);
  margin-right: 20px;
  margin-bottom: 10px;
}
.blue-btn {
  @include theme-fill-btn(96px, 36px, 14px, 4px);
}
</style>
